<template>
    <FeaturesWithMedia
        class="slice slice-features slice-features--with-image"
        :slice="props.slice"
        variation-modifier="with-image"
        default-anchor-id="features-with-image"
        :reverse="props.slice.primary.reverse"
    >
        <MuiImageWrapperWithShapes
            enable-full-screen
            :image1-url="image1Url"
            :image2-url="image2Url"
            :theme="props.slice.primary.theme"
            class="slice-features--with-image__media"
        />
    </FeaturesWithMedia>
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {FeaturesSlice} from '@prismicio-types';
    import {MuiImageWrapperWithShapes} from '#components';
    import FeaturesWithMedia from '../components/FeaturesWithMedia.vue';

    type FeaturesWithImageInZone = Extract<FeaturesSlice, {variation: 'featuresWithImage'}>;

    const props = defineProps(getSliceComponentProps<FeaturesWithImageInZone>());

    const {image1Url, image2Url} = getImageUrls();

    function getImageUrls() {
        const imageUrls = props.slice.items.map((item) => item.image.url);

        return {
            image1Url: imageUrls[0] ?? undefined,
            image2Url: imageUrls[1] ?? undefined,
        };
    }
</script>
